export function tabs() {
  return [
  {
    id: 1,
    label: 'Award overview',
    intlKey: 'tabs.award_overview',
    path: '/award-overview',
    type: 'tab'
  },
  {
    id: 2,
    label: 'Progress overview',
    intlKey: 'tabs.progress_overview',
    path: '/progress-overview',
    type: 'tab'
  }
  ]
}
